import React, { useState, useRef } from 'react';

const INITIAL_HEIGHT = 50; // Estimated height for ~3 lines of text
const FONT_SIZE = 14;      // Font size in pixels

function TextInputWithButton({ onSubmit }) {
  const [inputValue, setInputValue] = useState("");
  const [shake, setShake] = useState(false);
  const textareaRef = useRef(null);

  const submit = () => {
    // If the text is empty, trigger a shake animation instead of submitting.
    if (inputValue.trim() === "") {
      setShake(true);
      setTimeout(() => setShake(false), 500); // Shake animation duration 500ms
      return;
    }
    if (onSubmit) onSubmit(inputValue);
    // setInputValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.max(textareaRef.current.scrollHeight, INITIAL_HEIGHT);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'stretch', marginBottom: '10px' }}>
      <textarea
        ref={textareaRef}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Enter your coding query here..."
        style={{ 
          flex: 1, 
          resize: 'none', 
          overflow: 'hidden',
          borderRadius: '8px',
          padding: '8px',
          fontSize: `${FONT_SIZE}px`,
          height: `${INITIAL_HEIGHT}px`,
          minHeight: `${INITIAL_HEIGHT}px`,
          lineHeight: '1.2',
          animation: shake ? 'shake 0.5s' : 'none'
        }}
      />
      <button
        onClick={submit}
        style={{ 
          marginLeft: '10px',
          borderRadius: '8px', // Same corner radius as the textfield
          height: `${INITIAL_HEIGHT}px`
        }}
      >
        Enter
      </button>
    </div>
  );
}

export default TextInputWithButton;
